import { render, staticRenderFns } from "./FormTabsHeader.vue?vue&type=template&id=751927cc"
import script from "./FormTabsHeader.vue?vue&type=script&lang=ts"
export * from "./FormTabsHeader.vue?vue&type=script&lang=ts"
import style0 from "./FormTabsHeader.vue?vue&type=style&index=0&id=751927cc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports